// DesktopNav.jsx
import { useRef, useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import {
  navLinks,
  registrationServices,
  serviceCategories,
  advisoryServices
} from "./navData";

export default function DesktopNav() {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [activeCategory, setActiveCategory] = useState(null);

  const closeTimeoutRef = useRef(null);

  const openMenu = (menu) => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
    }
    setOpenDropdown(menu);
  };

  const scheduleCloseMenu = () => {
    closeTimeoutRef.current = setTimeout(() => {
      setOpenDropdown(null);
      setActiveCategory(null);
    }, 200);
  };

  const cancelCloseMenu = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
    }
  };

  const activateCategory = (name) => {
    setActiveCategory(name);
  };

  return (
    <div className="hidden lg:flex gap-2">
      {navLinks.map((link) => {
        if (!link.dropdown) {
          return (
            <a
              key={link.name}
              href={link.path}
              className="px-3 py-2 hover:bg-yellow-500 hover:text-black rounded transition-colors"
            >
              {link.name}
            </a>
          );
        }

        const data =
          link.dropdown === "registration"
            ? registrationServices
            : link.dropdown === "services"
            ? serviceCategories
            : advisoryServices;

        // Advisory simple dropdown
        if (link.dropdown === "advisory") {
          return (
            <div
              key={link.name}
              className="relative"
              onMouseEnter={() => openMenu(link.dropdown)}
              onMouseLeave={scheduleCloseMenu}
            >
              <button className="px-3 py-2 flex items-center gap-1 hover:bg-yellow-500 hover:text-black rounded transition-colors">
                {link.name}
                <ChevronDown size={14} />
              </button>

              {openDropdown === link.dropdown && (
                <div
                  className="absolute top-full mt-2 bg-white text-black shadow-xl rounded-lg z-50 w-80 max-h-[600px] overflow-y-auto"
                  onMouseEnter={cancelCloseMenu}
                  onMouseLeave={scheduleCloseMenu}
                >
                  <div className="p-2">
                    {advisoryServices.map((item) => (
                      <a
                        key={item.name}
                        href={item.path}
                        className="block px-3 py-2 text-sm hover:bg-yellow-50 rounded transition-colors"
                        onClick={() => setOpenDropdown(null)}
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>
          );
        }

        // Mega menu for registration/services
        return (
          <div
            key={link.name}
            className="relative"
            onMouseEnter={() => openMenu(link.dropdown)}
            onMouseLeave={scheduleCloseMenu}
          >
            <button className="px-3 py-2 flex items-center gap-1 hover:bg-yellow-500 hover:text-black rounded transition-colors">
              {link.name}
              <ChevronDown size={14} />
            </button>

            {openDropdown === link.dropdown && (
              <div
                className="absolute top-full mt-2 bg-white text-black shadow-xl rounded-lg flex z-50 max-h-[600px]"
                onMouseEnter={cancelCloseMenu}
                onMouseLeave={scheduleCloseMenu}
              >
                {/* Left column: categories */}
                <div className="w-80 p-2 overflow-y-auto">
                  {data.map((cat) => (
                    <div
                      key={cat.name}
                      onMouseEnter={() => activateCategory(cat.name)}
                      className={`flex justify-between items-center px-3 py-2 cursor-pointer rounded transition-colors ${
                        activeCategory === cat.name
                          ? "bg-yellow-50"
                          : "hover:bg-yellow-50"
                      }`}
                    >
                      <span className="text-sm font-medium">{cat.name}</span>
                      <ChevronRight size={14} />
                    </div>
                  ))}
                </div>

                {/* Right column: subitems */}
                {data.map(
                  (cat) =>
                    activeCategory === cat.name && (
                      <div
                        key={cat.name}
                        className="w-96 p-3 border-l border-gray-200 max-h-[600px] overflow-y-auto"
                      >
                        {cat.subItems.map((item) => (
                          <a
                            key={item.name}
                            href={item.path}
                            className="block px-3 py-2 text-sm hover:bg-yellow-50 rounded transition-colors"
                            onClick={() => {
                              setOpenDropdown(null);
                              setActiveCategory(null);
                            }}
                          >
                            {item.name}
                          </a>
                        ))}
                      </div>
                    )
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
